import { webApi } from '@mi-front/api-clients';
import { OptionType, StationFilterOption } from './types';

/**
 * Maps advanced station filter selections to BFF "stations filters" items (same semantics as GIP).
 * Pass the expected array type as `T` (or a wider body type slice) so the result matches your request DTO.
 */
export function mapStationFilterOptionsTo<T>(options: StationFilterOption[]): T {
  const mapped = options
    .map((filter) => {
      switch (filter.type) {
        case OptionType.StationType:
          return {
            type: webApi.StationsFiltersTypeEnum.STATION_TYPE,
            value: filter.value,
          };
        case OptionType.StationGroup:
          return {
            type: webApi.StationsFiltersTypeEnum2.STATION_GROUP,
            value: filter.value.id,
          };
        case OptionType.IndividualStation:
          return {
            type: webApi.StationsFiltersTypeEnum3.STATION_INDIVIDUAL,
            value: filter.value.id,
          };
        default:
          return null;
      }
    })
    .filter((filter) => filter !== null);

  return mapped as T;
}
